import { englishToSpanish } from "../data/url-alternates-data";

/**
 * Converts a branch location URL between English and Spanish.
 * @param {string} url - The current URL.
 * @returns {string | null} - The alternate URL, or null if not applicable.
 */
function getBranchAlternateUrl(url) {
  // Skip the ATM page; Doesn't have a Spanish version
  if (url === "/locations/atm") {
    return null;
  }

  if (url === "/locations" || url.startsWith("/locations/")) {
    return url.replace("/locations", "/es/sucursales").replace("new-mexico", "nuevo-mexico");
  } else if (url === "/es/sucursales" || url.startsWith("/es/sucursales/")) {
    return url.replace("/es/sucursales", "/locations").replace("nuevo-mexico", "new-mexico");
  }
  return null;
}

/**
 * Retrieves the alternate URL for a given page.
 * @param {string} currentUrl - The current page URL.
 * @returns {string | null} - The alternate URL, or null if not found.
 */
export function getAlternateUrl(currentUrl) {
  // Check if it's a branch location and return the dynamically generated URL
  const branchUrl = getBranchAlternateUrl(currentUrl);
  if (branchUrl) {
    return branchUrl;
  }

  // Direct lookup in JSON (English -> Spanish)
  if (englishToSpanish[currentUrl]) {
    return englishToSpanish[currentUrl];
  }

  // Reverse lookup (Spanish -> English)
  return Object.keys(englishToSpanish).find((englishUrl) => englishToSpanish[englishUrl] === currentUrl) || null;
}
